import { Box, Button, Dialog, Paper, Stack, styled } from "@mui/material";
import { toPx } from "../../MuiHelpers";
import { styledOmitPropsOptions } from "../../../theme/styled.helpers";

export const StepperCustomStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        height: "100%",
    }),
);

export const StepperInvisibleBox = styled(
    Box,
    styledOmitPropsOptions,
)(({ theme }) =>
    theme.unstable_sx({
        display: "none",
    }),
);

export const StepperCustomPaper = styled(Paper)<{ width: number | string }>(({ theme, width }) =>
    theme.unstable_sx({
        width: toPx(width) ?? "100%",
        height: "90vh",
        maxHeight: "700px",
        overflow: "hidden",
    }),
);

export const StepperCustomDialog = styled(Dialog)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiDialog-container": {
            alignItems: { xs: "end", md: "center" },
        },
    }),
);

export const ChangeSavingsStrategyButton = styled(Button)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: { md: "flex-start" },
        width: { md: "auto", xs: "100%" },
    }),
);
